// extracted by mini-css-extract-plugin
export var hideEditor = "_s0-2";
export var infoIcon = "_s0-3";
export var label = "_s0-1";
export var labelContainer = "_s0-0";
export var readonlyText = "_s0-4";